export default __webpack_public_path__ + "static/media/webgl_icon_black.30b2f264.svg";